
<div class="Motor">
       <div class="row">
           <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="InsuredInformation Infomation">
                    <div class="FormSection">
                            <div class="row">
                                    <span class="DriverLicenseDate">Insured Information</span>
                                </div>
                                <div class="Clears"></div>
                        <div class="Field">
                            <div class="row">
                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                    <label>Identification / Iqama Number</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                    <input type="text" class="form-control">
                                    </div>
                            </div>
                        </div>

                        <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label>Date of Birth</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                            <div class=" row dobfiled">
                                                    <div class="col-lg-3">
                                                     
                                                      <input class="form-control" placeholder="DD" type="text">
                                                    </div>
                                                    <div class="col-lg-3">
                                                           
                                                            <input class="form-control" placeholder="MM" type="text">
                                                          </div>
                                                          <div class="col-lg-3">
                                                           
                                                                <input class="form-control" placeholder="YYYY" type="text">
                                                              </div>
    
                                         </div>
                                                
                                </div>
                            </div>
                        </div>
                            <div class="Field">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                            <label>City</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                            <select class="form-control">
                                                <!-- <option selected>Choose City</option> -->
                                            </select>
                                            </div>
                                    </div>
                                </div>

                                <div class="Field">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                <label>Mobile</label>
                                            </div>
                                            <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                 <input type="text" placeholder="Mobile" class="form-control">
                                                </div>
                                        </div>
                                    </div>

                                    <div class="Field">

                                            <div class="checkbox checkbox-primary">
                                                    <input id="checkbox2" type="checkbox"  >
                                                    <label for="checkbox2">
                                                            I hereby give ACIG advance consent to obtain information of me and/or any vehicle under my ownership from the National Information Center.
                                                    </label>
                                                </div>
                                                                    
                                          
                                    </div>

                                   
                    </div>


                    <!-- Second Form Section -->

                    <div class="OTPForm" *ngIf="OTP">
                            <div class="Field">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                            <label>Verification Code</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                            

                                             <div class="row">
                                                 <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                                                        <input type="text" placeholder="Mobile" class="form-control">
                                                 </div>
                                                 <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                                     <input type="button" class="btn btn-primary Resend" value="Resend">
                                                    </div>
                                             </div>
                                            </div>
                                    </div>
                                </div>
                    </div>

<!-- Third Form Section -->

                    <div class="ThirdFormSection" *ngIf="License">
                        <div class="row">
                            <span class="DriverLicenseDate">Please enter driving license expiration date</span>
                        </div>
                        <div class="Clears"></div>
                            <div class="Field">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                            <label>Driving Licence Expiry Date</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                <div class=" row dobfiled">
                                                        <div class="col-lg-3">
                                                         
                                                          <input class="form-control" placeholder="DD" type="text">
                                                        </div>
                                                        <div class="col-lg-3">
                                                               
                                                                <input class="form-control" placeholder="MM" type="text">
                                                              </div>
                                                              <div class="col-lg-3">
                                                               
                                                                    <input class="form-control" placeholder="YYYY" type="text">
                                                                  </div>
        
                                             </div>
                                                    
                                    </div>
                                </div>
                            </div>
                    </div>
                  
<!-- Button Actions -->

<div class="Actionsection" *ngIf="!Vehicle">
        <div class="Actions">
                <div class="btn-group">
                                <button type="button" class="btn btn-default btns">Back</button>
                                <button type="button" class="btn btn-primary btns" (click)="Next()">Next</button>
                                
                            </div>
        </div>
</div>
                    
                    </div>
           </div>

           <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="VehicleInformation Infomation">
                        <div class="FormSection">

                                <div class="row">
                                        <span class="DriverLicenseDate">Vehicle Information</span>
                                    </div>
                                    <div class="Clears"></div>
                                <div class="Field">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                            <label>Are you the owner of the vehicle?</label>
                                        </div>
                                        <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                                                <label class="radio-inline">
                                                        <input name="radioGroup" id="radio1" value="option1" type="radio" >Yes
                                                      </label>
                                                        <label class="radio-inline">
                                                        <input name="radioGroup" id="radio1" value="option1" type="radio">No
                                                      </label>
                                                       
                                            </div>
                                    </div>
                                </div>
        
                                <div class="Field">
                                        <div class="row">
                                                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                                    <label>vehicle Identification Type</label>
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                                                        <label class="radio-inline">
                                                                <input name="radioGroup" id="radio1" value="option1" type="radio" >Sequence
                                                              </label>
                                                                <label class="radio-inline">
                                                                <input name="radioGroup" id="radio1" value="option1" type="radio">Custom
                                                              </label>
                                                               
                                                    </div>
                                            </div>
                                </div>
                                    <div class="Field">
                                            <div class="row">
                                                <div class="col-lg-4 col-md-3 col-sm-6 col-xs-12">
                                                    <label>Vehicle Usage</label>
                                                </div>
                                                <div class="col-lg-8 col-md-9 col-sm-6 col-xs-12">
                                                    <select class="form-control">
                                                        <!-- <option selected>Choose City</option> -->
                                                    </select>
                                                    </div>
                                            </div>
                                        </div>
        
                                         
         
                            </div>

                            <!-- Button Actions -->

                            
<div class="Actionsection" *ngIf="Vehicle">
        <div class="Actions">
                <div class="btn-group">
                                <button type="button" class="btn btn-default btns">Back</button>
                                <button type="button" class="btn btn-primary btns" (click)="Dashboard()" >Next</button>
                                
                            </div>
        </div>
</div>
                    </div>
            </div>
       </div>
        

       
       
</div>





// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Motor/Motor.html